import { render, staticRenderFns } from "./BaseStepper.vue?vue&type=template&id=dc542ae2&scoped=true"
import script from "./BaseStepper.vue?vue&type=script&lang=js"
export * from "./BaseStepper.vue?vue&type=script&lang=js"
import style0 from "./BaseStepper.vue?vue&type=style&index=0&id=dc542ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc542ae2",
  null
  
)

export default component.exports